export interface StatRowProps {
   label?: string;
   value: React.ReactNode;
   icon?: React.ReactNode;
   color?: string;
   labelColor?: string;
   size?: 'sm' | 'md';
   align?: 'left' | 'center' | 'right';
   onClick?: () => void;
}

const StatRow: React.FC<StatRowProps> = ({
      label,
      value,
      icon,
      color = 'text-gray-200',
      labelColor = 'text-gray-400',
      size = 'sm',
      align = 'left',
      onClick,
   }) => {
   const textSize = size === 'md' ? 'text-sm' : 'text-xs';
   const Wrapper = onClick ? 'button' : 'div';
   
   const alignClass = {
      left:   'justify-between',
      center: 'justify-center gap-2',
      right:  'justify-end gap-2',
   }[align];
   
   return (
      <Wrapper
         onClick={onClick}
         className={`flex items-center w-full ${textSize} ${alignClass} ${
            onClick ? 'hover:bg-gray-700 rounded-lg px-2.5 py-1.5 cursor-pointer transition-colors -mx-2.5' : 'py-0.5'
         }`}
      >
         {(label || icon) && (
            <span className={`${labelColor} flex items-center gap-1.5`}>
               {icon && <span>{icon}</span>}
               {label}
            </span>
         )}
         <span className={`${color} font-mono`}>{value}</span>
      </Wrapper>
   );
};

export default StatRow;